// IE and Edge do not support welle the `flat()` method of array
// Issue: https://github.com/babel/babel/issues/9749
// One possible solution is to use `core-js@3.0.0` but has breaking changes from the v2.x version
// and i'm not brave enough to try to change it :-)
// 
// Ref: https://stackoverflow.com/questions/50993498/flat-is-not-a-function-whats-wrong
if (!Array.prototype.flat) {
  Object.defineProperty(Array.prototype, 'flat', {
    value: function(depth = 1) {
      return this.reduce(function (flat, toFlatten) {
        return flat.concat(
          (Array.isArray(toFlatten) && (depth > 1)) ? toFlatten.flat(depth - 1) : toFlatten
        )
      }, [])
    }
  })
}